import React, { useState, useEffect, useCallback } from 'react';
import './../../App.css';
import './Transactions.css';
import {CreateButton, CreateSearchBarWithPlaceHolder} from './../CommonObjects';
import axios from 'axios';
import {CreateTableForEmployeeSelect} from './../ManageTable';
import {token, domain} from './../Security';
import loadingSpinner from './../../assets/loading.gif';
import {useTable, useSortBy} from 'react-table';
// icons
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ClearIcon from '@mui/icons-material/Clear';
import NoteAddIcon from '@mui/icons-material/NoteAdd';

function ApproverHierarchyPerLocation({isHideSideMenu}) {
    var header = [
        "Location Id",
        "Location",
        "Primary Approver",
        "Secondary Approver",
        "Tertiary Approver",
        "",
    ]
    var accessor = [
        "locationId",
        "locationDescription",
        "primaryApprover[0]",
        "secondaryApprover[0]",
        "tertiaryApprover[0]",
        "manage"
    ]

    const [currentPage, setCurrentPage] = useState(1);

    const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [approverHierarchy, setApproverHierarchy] = useState([]);
    
    const [filterData, setFilterData] = useState([]);

    const [employees, setEmployees] = useState([]);

    // Add
    const [showAddForm, setShowAddForm] = useState(false);
    const [showEditForm, setShowEditForm] = useState(false);
    const [locationDescription, setLocationDescription] = useState("");
    const [locationId, setLocationId] = useState("");
    const [primaryApproverId, setPrimaryApproverId] = useState("");
    const [primaryApproverFullName, setPrimaryApproverFullName] = useState("");
    const [primaryApproverId2, setPrimaryApproverId2] = useState("");
    const [primaryApproverFullName2, setPrimaryApproverFullName2] = useState("");
    const [primaryApproverId3, setPrimaryApproverId3] = useState("");
    const [primaryApproverFullName3, setPrimaryApproverFullName3] = useState("");
    const [primaryApproverId4, setPrimaryApproverId4] = useState("");
    const [primaryApproverFullName4, setPrimaryApproverFullName4] = useState("");
    const [secondaryApproverId, setSecondaryApproverId] = useState("");
    const [secondaryApproverFullName, setSecondaryApproverFullName] = useState("");
    const [secondaryApproverId2, setSecondaryApproverId2] = useState("");
    const [secondaryApproverFullName2, setSecondaryApproverFullName2] = useState("");
    const [secondaryApproverId3, setSecondaryApproverId3] = useState("");
    const [secondaryApproverFullName3, setSecondaryApproverFullName3] = useState("");
    const [secondaryApproverId4, setSecondaryApproverId4] = useState("");
    const [secondaryApproverFullName4, setSecondaryApproverFullName4] = useState("");
    const [tertiaryApproverId, setTertiaryApproverId] = useState("");
    const [tertiaryApproverFullName, setTertiaryApproverFullName] = useState("");
    const [tertiaryApproverId2, setTertiaryApproverId2] = useState("");
    const [tertiaryApproverFullName2, setTertiaryApproverFullName2] = useState("");
    const [tertiaryApproverId3, setTertiaryApproverId3] = useState("");
    const [tertiaryApproverFullName3, setTertiaryApproverFullName3] = useState("");
    const [tertiaryApproverId4, setTertiaryApproverId4] = useState("");
    const [tertiaryApproverFullName4, setTertiaryApproverFullName4] = useState("");
    //Approver
    const [showLocationSelect, setShowLocationSelect] = useState(false);
    const [showPrimaryApprover, setShowPrimaryApprover] = useState(false);
    const [showPrimaryApprover2, setShowPrimaryApprover2] = useState(false);
    const [showPrimaryApprover3, setShowPrimaryApprover3] = useState(false);
    const [showPrimaryApprover4, setShowPrimaryApprover4] = useState(false);
    const [showSecondaryApprover, setShowSecondaryApprover] = useState(false);
    const [showSecondaryApprover2, setShowSecondaryApprover2] = useState(false);
    const [showSecondaryApprover3, setShowSecondaryApprover3] = useState(false);
    const [showSecondaryApprover4, setShowSecondaryApprover4] = useState(false);
    const [showTertiaryApprover, setShowTertiaryApprover] = useState(false);
    const [showTertiaryApprover2, setShowTertiaryApprover2] = useState(false);
    const [showTertiaryApprover3, setShowTertiaryApprover3] = useState(false);
    const [showTertiaryApprover4, setShowTertiaryApprover4] = useState(false);

    const [showClearForm, setShowClearForm] = useState(false);

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const [isSetMainHierarchyOnce, setIsSetMainHierarchyOnce] = useState(false);
    const [mainApproverHierarchy, setMainApproverHierarchy] = useState([]);

    const fetchDataMainApproverHierarchy = useCallback(async () => {
        try {
            const apiUrl =  domain + "/api/ApproverHierarchy";
            const response = await axios.get(apiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            setMainApproverHierarchy(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    const apiUrl =  domain + "/api/LocationApproverHierarchy";

    const fetchDataForEmployee = useCallback(async () => {
        const apiUrl =  domain + "/api/Employee/single-data";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const response = await axios.get(apiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            const result = await fetchDataForEmployee();
            setEmployees(result);

            if(!isSetMainHierarchyOnce){
                setIsSetMainHierarchyOnce(true);
                
                await fetchDataMainApproverHierarchy();
            }

            setApproverHierarchy(response.data); // Set the response data to the state
            setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [apiUrl, isSetMainHierarchyOnce, fetchDataForEmployee, fetchDataMainApproverHierarchy]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();

        var res = filterData.filter((f) =>
        f.locationDescription.toLowerCase().includes(lowercaseValue));

        setApproverHierarchy(res);
    };
    const handleSubmit = async (event) => {
        event.preventDefault();

        const foundEmployeesPerLocation = employees.filter(employee => employee.employeeInformation 
            && employee.employeeInformation.locationId 
            && employee.employeeInformation.locationId === locationId);
        const foundEmployeesInMainApprover = mainApproverHierarchy.filter(approver => 
            ((approver.primaryApprover &&
                (approver.primaryApprover.primaryApprover1Id ||
                approver.primaryApprover.primaryApprover2Id ||
                approver.primaryApprover.primaryApprover3Id ||
                approver.primaryApprover.primaryApprover4Id)) ||
            (approver.secondaryApprover &&
                (approver.secondaryApprover.secondaryApprover1Id ||
                approver.secondaryApprover.secondaryApprover2Id ||
                approver.secondaryApprover.secondaryApprover3Id ||
                approver.secondaryApprover.secondaryApprover4Id)) ||
            (approver.tertiaryApprover &&
                (approver.tertiaryApprover.tertiaryApprover1Id ||
                approver.tertiaryApprover.tertiaryApprover2Id ||
                approver.tertiaryApprover.tertiaryApprover3Id ||
                approver.tertiaryApprover.tertiaryApprover4Id)))
            &&
            foundEmployeesPerLocation.some(employee => employee.id === approver.employeePersonalInformationId && employee?.employeeInformation.classificationId !== 1) //monthly
        );

        if(primaryApproverId
            || primaryApproverId2
            || primaryApproverId3
            || primaryApproverId4
            || secondaryApproverId
            || secondaryApproverId2
            || secondaryApproverId3
            || secondaryApproverId4
            || tertiaryApproverId
            || tertiaryApproverId2
            || tertiaryApproverId3
            || tertiaryApproverId4
        ){
            if (foundEmployeesInMainApprover.length > 0) {
                setShowRequestMessage(true);
                setIsSuccess(false);
                
                // Extract full names of found employees
                const employeeNames = foundEmployeesInMainApprover.map(emp => emp.employeePersonalInformationFullName).join(", ");
            
                // Set the error message including all found employees
                setRequestMessage(`Employees: ${employeeNames} under ${locationDescription} are already set in Main Approver Hierarchy.`);
                
                return;
            }
        }

        const data = {
            locationId: locationId,
            primaryApprovers: [
                primaryApproverId && { approverId: primaryApproverId },
                primaryApproverId2 && { approverId: primaryApproverId2 },
                primaryApproverId3 && { approverId: primaryApproverId3 },
                primaryApproverId4 && { approverId: primaryApproverId4 },
            ].filter(Boolean),
            secondaryApprovers: [
                secondaryApproverId && { approverId: secondaryApproverId },
                secondaryApproverId2 && { approverId: secondaryApproverId2 },
                secondaryApproverId3 && { approverId: secondaryApproverId3 },
                secondaryApproverId4 && { approverId: secondaryApproverId4 },
            ].filter(Boolean),
            tertiaryApprovers: [
                tertiaryApproverId && { approverId: tertiaryApproverId },
                tertiaryApproverId2 && { approverId: tertiaryApproverId2 },
                tertiaryApproverId3 && { approverId: tertiaryApproverId3 },
                tertiaryApproverId4 && { approverId: tertiaryApproverId4 },
            ].filter(Boolean)
        };

        /* const checkApprovers = (approvers, mainApproverHierarchy) => {
            const names = []; // Array to collect names of matching approvers
        
            for (const approver of approvers) {
                const approverIdToCheck = approver.approverId;
        
                const isApproverAlreadyPresent = mainApproverHierarchy.some(hierarchy => {
                    const primaryApprovers = hierarchy.primaryApprover || {};
                    const secondaryApprovers = hierarchy.secondaryApprover || {};
                    const tertiaryApprovers = hierarchy.tertiaryApprover || {};
        
                    // Check primary approvers
                    if (primaryApprovers.primaryApprover1Id === approverIdToCheck) {
                        names.push(primaryApprovers.primaryApprover1FullName);
                    }
                    if (primaryApprovers.primaryApprover2Id === approverIdToCheck) {
                        names.push(primaryApprovers.primaryApprover2FullName);
                    }
                    if (primaryApprovers.primaryApprover3Id === approverIdToCheck) {
                        names.push(primaryApprovers.primaryApprover3FullName);
                    }
                    if (primaryApprovers.primaryApprover4Id === approverIdToCheck) {
                        names.push(primaryApprovers.primaryApprover4FullName);
                    }
                    // Check secondary approvers
                    if (secondaryApprovers.secondaryApprover1Id === approverIdToCheck) {
                        names.push(secondaryApprovers.secondaryApprover1FullName);
                    }
                    if (secondaryApprovers.secondaryApprover2Id === approverIdToCheck) {
                        names.push(secondaryApprovers.secondaryApprover2FullName);
                    }
                    if (secondaryApprovers.secondaryApprover3Id === approverIdToCheck) {
                        names.push(secondaryApprovers.secondaryApprover3FullName);
                    }
                    if (secondaryApprovers.secondaryApprover4Id === approverIdToCheck) {
                        names.push(secondaryApprovers.secondaryApprover4FullName);
                    }
                    // Check tertiary approvers
                    if (tertiaryApprovers.tertiaryApprover1Id === approverIdToCheck) {
                        names.push(tertiaryApprovers.tertiaryApprover1FullName);
                    }
                    if (tertiaryApprovers.tertiaryApprover2Id === approverIdToCheck) {
                        names.push(tertiaryApprovers.tertiaryApprover2FullName);
                    }
                    if (tertiaryApprovers.tertiaryApprover3Id === approverIdToCheck) {
                        names.push(tertiaryApprovers.tertiaryApprover3FullName);
                    }
                    if (tertiaryApprovers.tertiaryApprover4Id === approverIdToCheck) {
                        names.push(tertiaryApprovers.tertiaryApprover4FullName);
                    }
        
                    return names.length > 0; // Stop checking if any name is found
                });
        
                if (isApproverAlreadyPresent) {
                    // Return the collected names if an approver is already present
                    return { exists: true, names };
                }
            }
        
            // Return false if no approver is found, with an empty names array
            return { exists: false, names };
        };
        
        // Check all primary, secondary, and tertiary approvers
        const primaryApproversCheck = checkApprovers(data.primaryApprovers, mainApproverHierarchy);
        const secondaryApproversCheck = checkApprovers(data.secondaryApprovers, mainApproverHierarchy);
        const tertiaryApproversCheck = checkApprovers(data.tertiaryApprovers, mainApproverHierarchy);
        
        // Combine results
        const allApproversCheck = {
            exists: primaryApproversCheck.exists || secondaryApproversCheck.exists || tertiaryApproversCheck.exists,
            names: [
                ...primaryApproversCheck.names,
                ...secondaryApproversCheck.names,
                ...tertiaryApproversCheck.names
            ]
        };
        
        if (allApproversCheck.exists) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage(`${allApproversCheck.names.join(', ')} is/ are already approver/s in Approver Hierarchy`);

            return;
        } */

        try {
            setLoadingRequest(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            setShowAddForm(false); // Hide the add form
            setShowEditForm(false);
            
            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setLocationDescription("");
            setLocationId("");

            setPrimaryApproverId("");
            setPrimaryApproverId2("");
            setPrimaryApproverId3("");
            setPrimaryApproverId4("");
            setPrimaryApproverFullName("");
            setPrimaryApproverFullName2("");
            setPrimaryApproverFullName3("");
            setPrimaryApproverFullName4("");

            setSecondaryApproverId("");
            setSecondaryApproverId2("");
            setSecondaryApproverId3("");
            setSecondaryApproverId4("");
            setSecondaryApproverFullName("");
            setSecondaryApproverFullName2("");
            setSecondaryApproverFullName3("");
            setSecondaryApproverFullName4("");

            setTertiaryApproverId("");
            setTertiaryApproverId2("");
            setTertiaryApproverId3("");
            setTertiaryApproverId4("");
            setTertiaryApproverFullName("");
            setTertiaryApproverFullName2("");
            setTertiaryApproverFullName3("");
            setTertiaryApproverFullName4("");
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowAddForm(false);
        setShowEditForm(false);
    };
    const handleClear = async (event) => {
        event.preventDefault();

        const data = {
            locationId: locationId,
            primaryApprovers: [],
            secondaryApprovers: [],
            tertiaryApprovers: []
        };

        try {
            setLoadingRequest(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            setShowClearForm(false); // Hide the add form
            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setLocationDescription("");
            setLocationId("");

            setPrimaryApproverId("");
            setPrimaryApproverId2("");
            setPrimaryApproverId3("");
            setPrimaryApproverId4("");
            setPrimaryApproverFullName("");
            setPrimaryApproverFullName2("");
            setPrimaryApproverFullName3("");
            setPrimaryApproverFullName4("");

            setSecondaryApproverId("");
            setSecondaryApproverId2("");
            setSecondaryApproverId3("");
            setSecondaryApproverId4("");
            setSecondaryApproverFullName("");
            setSecondaryApproverFullName2("");
            setSecondaryApproverFullName3("");
            setSecondaryApproverFullName4("");

            setTertiaryApproverId("");
            setTertiaryApproverId2("");
            setTertiaryApproverId3("");
            setTertiaryApproverId4("");
            setTertiaryApproverFullName("");
            setTertiaryApproverFullName2("");
            setTertiaryApproverFullName3("");
            setTertiaryApproverFullName4("");
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowClearForm(false);
    };

    const addHandleClick = (data) => {
        if(employees.length <= 0){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Please wait the data to load first.");
            return;
        }

        setShowAddForm(true);
        setLocationId(data.locationId);
        setLocationDescription(data.locationDescription);

        if(data.primaryApprover){
            setPrimaryApproverId(data.primaryApprover.primaryApprover1Id ? data.primaryApprover.primaryApprover1Id : "");
            setPrimaryApproverFullName(data.primaryApprover.primaryApprover1FullName ? data.primaryApprover.primaryApprover1FullName : "");
            setPrimaryApproverId2(data.primaryApprover.primaryApprover2Id ? data.primaryApprover.primaryApprover2Id : "");
            setPrimaryApproverFullName2(data.primaryApprover.primaryApprover2FullName ? data.primaryApprover.primaryApprover2FullName : "");
            setPrimaryApproverId3(data.primaryApprover.primaryApprover3Id ? data.primaryApprover.primaryApprover3Id : "");
            setPrimaryApproverFullName3(data.primaryApprover.primaryApprover3FullName ? data.primaryApprover.primaryApprover3FullName : "");
            setPrimaryApproverId4(data.primaryApprover.primaryApprover4Id ? data.primaryApprover.primaryApprover4Id : "");
            setPrimaryApproverFullName4(data.primaryApprover.primaryApprover4FullName ? data.primaryApprover.primaryApprover4FullName : "");
        }

        if(data.secondaryApprover){
            setSecondaryApproverId(data.secondaryApprover.secondaryApprover1Id ? data.secondaryApprover.secondaryApprover1Id : "");
            setSecondaryApproverFullName(data.secondaryApprover.secondaryApprover1FullName ? data.secondaryApprover.secondaryApprover1FullName : "");
            setSecondaryApproverId2(data.secondaryApprover.secondaryApprover2Id ? data.secondaryApprover.secondaryApprover2Id : "");
            setSecondaryApproverFullName2(data.secondaryApprover.secondaryApprover2FullName ? data.secondaryApprover.secondaryApprover2FullName : "");
            setSecondaryApproverId3(data.secondaryApprover.secondaryApprover3Id ? data.secondaryApprover.secondaryApprover3Id : "");
            setSecondaryApproverFullName3(data.secondaryApprover.secondaryApprover3FullName ? data.secondaryApprover.secondaryApprover3FullName : "");
            setSecondaryApproverId4(data.secondaryApprover.secondaryApprover4Id ? data.secondaryApprover.secondaryApprover4Id : "");
            setSecondaryApproverFullName4(data.secondaryApprover.secondaryApprover4FullName ? data.secondaryApprover.secondaryApprover4FullName : "");
        }

        if(data.tertiaryApprover){
            setTertiaryApproverId(data.tertiaryApprover.tertiaryApprover1Id ? data.tertiaryApprover.tertiaryApprover1Id : "");
            setTertiaryApproverFullName(data.tertiaryApprover.tertiaryApprover1FullName ? data.tertiaryApprover.tertiaryApprover1FullName : "");
            setTertiaryApproverId2(data.tertiaryApprover.tertiaryApprover2Id ? data.tertiaryApprover.tertiaryApprover2Id : "");
            setTertiaryApproverFullName2(data.tertiaryApprover.tertiaryApprover2FullName ? data.tertiaryApprover.tertiaryApprover2FullName : "");
            setTertiaryApproverId3(data.tertiaryApprover.tertiaryApprover3Id ? data.tertiaryApprover.tertiaryApprover3Id : "");
            setTertiaryApproverFullName3(data.tertiaryApprover.tertiaryApprover3FullName ? data.tertiaryApprover.tertiaryApprover3FullName : "");
            setTertiaryApproverId4(data.tertiaryApprover.tertiaryApprover4Id ? data.tertiaryApprover.tertiaryApprover4Id : "");
            setTertiaryApproverFullName4(data.tertiaryApprover.tertiaryApprover4FullName ? data.tertiaryApprover.tertiaryApprover4FullName : "");
        }
    };
    const editHandleClick = (data) => {
        setShowEditForm(true);
        setLocationId(data.locationId);
        setLocationDescription(data.locationDescription);

        if(data.primaryApprovers){
            setPrimaryApproverId(data.primaryApprovers && data.primaryApprovers[0] &&  data.primaryApprovers[0].approverId ?  data.primaryApprovers[0].approverId : "");
            setPrimaryApproverFullName(data.primaryApprovers && data.primaryApprovers[0] &&  data.primaryApprovers[0].approverFullName ?  data.primaryApprovers[0].approverFullName : "");
            setPrimaryApproverId2(data.primaryApprovers && data.primaryApprovers[1] &&  data.primaryApprovers[1].approverId ?  data.primaryApprovers[1].approverId : "");
            setPrimaryApproverFullName2(data.primaryApprovers && data.primaryApprovers[1] &&  data.primaryApprovers[1].approverFullName ?  data.primaryApprovers[1].approverFullName : "");
            setPrimaryApproverId3(data.primaryApprovers && data.primaryApprovers[2] &&  data.primaryApprovers[2].approverId ?  data.primaryApprovers[2].approverId : "");
            setPrimaryApproverFullName3(data.primaryApprovers && data.primaryApprovers[2] &&  data.primaryApprovers[2].approverFullName ?  data.primaryApprovers[2].approverFullName : "");
            setPrimaryApproverId4(data.primaryApprovers && data.primaryApprovers[3] &&  data.primaryApprovers[3].approverId ?  data.primaryApprovers[3].approverId : "");
            setPrimaryApproverFullName4(data.primaryApprovers && data.primaryApprovers[3] &&  data.primaryApprovers[3].approverFullName ?  data.primaryApprovers[3].approverFullName : "");
        }

        if(data.secondaryApprovers){
            setSecondaryApproverId(data.secondaryApprovers && data.secondaryApprovers[0] &&  data.secondaryApprovers[0].approverId ?  data.secondaryApprovers[0].approverId : "");
            setSecondaryApproverFullName(data.secondaryApprovers && data.secondaryApprovers[0] &&  data.secondaryApprovers[0].approverFullName ?  data.secondaryApprovers[0].approverFullName : "");
            setSecondaryApproverId2(data.secondaryApprovers && data.secondaryApprovers[1] &&  data.secondaryApprovers[1].approverId ?  data.secondaryApprovers[1].approverId : "");
            setSecondaryApproverFullName2(data.secondaryApprovers && data.secondaryApprovers[1] &&  data.secondaryApprovers[1].approverFullName ?  data.secondaryApprovers[1].approverFullName : "");
            setSecondaryApproverId3(data.secondaryApprovers && data.secondaryApprovers[2] &&  data.secondaryApprovers[2].approverId ?  data.secondaryApprovers[2].approverId : "");
            setSecondaryApproverFullName3(data.secondaryApprovers && data.secondaryApprovers[2] &&  data.secondaryApprovers[2].approverFullName ?  data.secondaryApprovers[2].approverFullName : "");
            setSecondaryApproverId4(data.secondaryApprovers && data.secondaryApprovers[3] &&  data.secondaryApprovers[3].approverId ?  data.secondaryApprovers[3].approverId : "");
            setSecondaryApproverFullName4(data.secondaryApprovers && data.secondaryApprovers[3] &&  data.secondaryApprovers[3].approverFullName ?  data.secondaryApprovers[3].approverFullName : "");
        }

        if(data.tertiaryApprovers){
            setTertiaryApproverId(data.tertiaryApprovers && data.tertiaryApprovers[0] &&  data.tertiaryApprovers[0].approverId ?  data.tertiaryApprovers[0].approverId : "");
            setTertiaryApproverFullName(data.tertiaryApprovers && data.tertiaryApprovers[0] &&  data.tertiaryApprovers[0].approverFullName ?  data.tertiaryApprovers[0].approverFullName : "");
            setTertiaryApproverId2(data.tertiaryApprovers && data.tertiaryApprovers[1] &&  data.tertiaryApprovers[1].approverId ?  data.tertiaryApprovers[1].approverId : "");
            setTertiaryApproverFullName2(data.tertiaryApprovers && data.tertiaryApprovers[1] &&  data.tertiaryApprovers[1].approverFullName ?  data.tertiaryApprovers[1].approverFullName : "");
            setTertiaryApproverId3(data.tertiaryApprovers && data.tertiaryApprovers[2] &&  data.tertiaryApprovers[2].approverId ?  data.tertiaryApprovers[2].approverId : "");
            setTertiaryApproverFullName3(data.tertiaryApprovers && data.tertiaryApprovers[2] &&  data.tertiaryApprovers[2].approverFullName ?  data.tertiaryApprovers[2].approverFullName : "");
            setTertiaryApproverId4(data.tertiaryApprovers && data.tertiaryApprovers[3] &&  data.tertiaryApprovers[3].approverId ?  data.tertiaryApprovers[3].approverId : "");
            setTertiaryApproverFullName4(data.tertiaryApprovers && data.tertiaryApprovers[3] &&  data.tertiaryApprovers[3].approverFullName ?  data.tertiaryApprovers[3].approverFullName : "");
        }
    };
    const closeAddHandleClick = () => {
        setShowAddForm(false);
    };
    const closeEditHandleClick = () => {
        setShowEditForm(false);
    };
    const closePrimaryApprover = () => {
        setShowPrimaryApprover(false);
    };
    const closeLocationSelect = () => {
        setShowLocationSelect(false);
    };
    const closePrimaryApprover2 = () => {
        setShowPrimaryApprover2(false);
    };
    const closePrimaryApprover3 = () => {
        setShowPrimaryApprover3(false);
    };
    const closePrimaryApprover4 = () => {
        setShowPrimaryApprover4(false);
    };
    const closeSecondaryApprover = () => {
        setShowSecondaryApprover(false);
    };
    const closeSecondaryApprover2 = () => {
        setShowSecondaryApprover2(false);
    };
    const closeSecondaryApprover3 = () => {
        setShowSecondaryApprover3(false);
    };
    const closeSecondaryApprover4 = () => {
        setShowSecondaryApprover4(false);
    };
    const closeTertiaryApprover = () => {
        setShowTertiaryApprover(false);
    };
    const closeTertiaryApprover2 = () => {
        setShowTertiaryApprover2(false);
    };
    const closeTertiaryApprover3 = () => {
        setShowTertiaryApprover3(false);
    };
    const closeTertiaryApprover4 = () => {
        setShowTertiaryApprover4(false);
    };

    const openClearForm = (data) => {
        setLocationId(data.locationId);
        setShowClearForm(true);
    };
    const closeClearForm = () => {
        setShowClearForm(false);
    };

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="TransactionInfo shadow-xl">
                        <div className="transaction-header">
                        <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Transactions >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Approver Hierarchy Per Location"}</span>
                        </div>
                            <h3>Approver Hierarchy  Per Location</h3>
                        </div>
                        <div className="transaction-body">
                            <div className="transaction-body-top row">
                                {CreateSearchBarWithPlaceHolder("", 
                                                                "transaction-search row", 
                                                                "transaction-search-icon", 
                                                                "transaction-search-input", 
                                                                (e)=>handleFilter(e.target.value), 
                                                                "Search by Location",
                                                                SearchIcon)}
                                <div className="transaction-addBtn row">
                                    {CreateButton("", "add row", addHandleClick, "ADD", NoteAddIcon)}
                                </div>
                            </div>

                            <div className="transaction-table container">
                                <CreateTable
                                    dataList={approverHierarchy}
                                    dataHeader={header}
                                    dataAccessor={accessor}
                                    editHandleClick={editHandleClick}
                                    deleteHandleClick={openClearForm}
                                    employees={employees}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddForm  isOpen={showAddForm} 
                    onClose={closeAddHandleClick}
                    locationDescription={locationDescription}
                    locationId={locationId}
                    primaryApproverId={primaryApproverId}
                    primaryApproverFullName={primaryApproverFullName}
                    primaryApproverId2={primaryApproverId2}
                    primaryApproverFullName2={primaryApproverFullName2}
                    primaryApproverId3={primaryApproverId3}
                    primaryApproverFullName3={primaryApproverFullName3}
                    primaryApproverId4={primaryApproverId4}
                    primaryApproverFullName4={primaryApproverFullName4}
                    secondaryApproverId={secondaryApproverId}
                    secondaryApproverFullName={secondaryApproverFullName}
                    secondaryApproverId2={secondaryApproverId2}
                    secondaryApproverFullName2={secondaryApproverFullName2}
                    secondaryApproverId3={secondaryApproverId3}
                    secondaryApproverFullName3={secondaryApproverFullName3}
                    secondaryApproverId4={secondaryApproverId4}
                    secondaryApproverFullName4={secondaryApproverFullName4}
                    tertiaryApproverId={tertiaryApproverId}
                    tertiaryApproverFullName={tertiaryApproverFullName}
                    tertiaryApproverId2={tertiaryApproverId2}
                    tertiaryApproverFullName2={tertiaryApproverFullName2}
                    tertiaryApproverId3={tertiaryApproverId3}
                    tertiaryApproverFullName3={tertiaryApproverFullName3}
                    tertiaryApproverId4={tertiaryApproverId4}
                    tertiaryApproverFullName4={tertiaryApproverFullName4}
                    setLocationDescription={setLocationDescription}
                    setLocationId={setLocationId}
                    setShowLocationSelect={setShowLocationSelect}
                    setShowPrimaryApprover={setShowPrimaryApprover}
                    setShowPrimaryApprover2={setShowPrimaryApprover2}
                    setShowPrimaryApprover3={setShowPrimaryApprover3}
                    setShowPrimaryApprover4={setShowPrimaryApprover4}
                    setShowSecondaryApprover={setShowSecondaryApprover}
                    setShowSecondaryApprover2={setShowSecondaryApprover2}
                    setShowSecondaryApprover3={setShowSecondaryApprover3}
                    setShowSecondaryApprover4={setShowSecondaryApprover4}
                    setShowTertiaryApprover={setShowTertiaryApprover}
                    setShowTertiaryApprover2={setShowTertiaryApprover2}
                    setShowTertiaryApprover3={setShowTertiaryApprover3}
                    setShowTertiaryApprover4={setShowTertiaryApprover4}
                    setPrimaryApproverFullName={setPrimaryApproverFullName}
                    setPrimaryApproverFullName2={setPrimaryApproverFullName2}
                    setPrimaryApproverFullName3={setPrimaryApproverFullName3}
                    setPrimaryApproverFullName4={setPrimaryApproverFullName4}
                    setSecondaryApproverFullName={setSecondaryApproverFullName}
                    setSecondaryApproverFullName2={setSecondaryApproverFullName2}
                    setSecondaryApproverFullName3={setSecondaryApproverFullName3}
                    setSecondaryApproverFullName4={setSecondaryApproverFullName4}
                    setTertiaryApproverFullName={setTertiaryApproverFullName}
                    setTertiaryApproverFullName2={setTertiaryApproverFullName2}
                    setTertiaryApproverFullName3={setTertiaryApproverFullName3}
                    setTertiaryApproverFullName4={setTertiaryApproverFullName4}
                    setPrimaryApproverId={setPrimaryApproverId}
                    setPrimaryApproverId2={setPrimaryApproverId2}
                    setPrimaryApproverId3={setPrimaryApproverId3}
                    setPrimaryApproverId4={setPrimaryApproverId4}
                    setSecondaryApproverId={setSecondaryApproverId}
                    setSecondaryApproverId2={setSecondaryApproverId2}
                    setSecondaryApproverId3={setSecondaryApproverId3}
                    setSecondaryApproverId4={setSecondaryApproverId4}
                    setTertiaryApproverId={setTertiaryApproverId}
                    setTertiaryApproverId2={setTertiaryApproverId2}
                    setTertiaryApproverId3={setTertiaryApproverId3}
                    setTertiaryApproverId4={setTertiaryApproverId4}
                    handleSubmit={handleSubmit}
            >
            </AddForm>
            <EditForm  isOpen={showEditForm} 
                    onClose={closeEditHandleClick}
                    locationDescription={locationDescription}
                    locationId={locationId}
                    primaryApproverId={primaryApproverId}
                    primaryApproverFullName={primaryApproverFullName}
                    primaryApproverId2={primaryApproverId2}
                    primaryApproverFullName2={primaryApproverFullName2}
                    primaryApproverId3={primaryApproverId3}
                    primaryApproverFullName3={primaryApproverFullName3}
                    primaryApproverId4={primaryApproverId4}
                    primaryApproverFullName4={primaryApproverFullName4}
                    secondaryApproverId={secondaryApproverId}
                    secondaryApproverFullName={secondaryApproverFullName}
                    secondaryApproverId2={secondaryApproverId2}
                    secondaryApproverFullName2={secondaryApproverFullName2}
                    secondaryApproverId3={secondaryApproverId3}
                    secondaryApproverFullName3={secondaryApproverFullName3}
                    secondaryApproverId4={secondaryApproverId4}
                    secondaryApproverFullName4={secondaryApproverFullName4}
                    tertiaryApproverId={tertiaryApproverId}
                    tertiaryApproverFullName={tertiaryApproverFullName}
                    tertiaryApproverId2={tertiaryApproverId2}
                    tertiaryApproverFullName2={tertiaryApproverFullName2}
                    tertiaryApproverId3={tertiaryApproverId3}
                    tertiaryApproverFullName3={tertiaryApproverFullName3}
                    tertiaryApproverId4={tertiaryApproverId4}
                    tertiaryApproverFullName4={tertiaryApproverFullName4}
                    setLocationDescription={setLocationDescription}
                    setLocationId={setLocationId}
                    setShowLocationSelect={setShowLocationSelect}
                    setShowPrimaryApprover={setShowPrimaryApprover}
                    setShowPrimaryApprover2={setShowPrimaryApprover2}
                    setShowPrimaryApprover3={setShowPrimaryApprover3}
                    setShowPrimaryApprover4={setShowPrimaryApprover4}
                    setShowSecondaryApprover={setShowSecondaryApprover}
                    setShowSecondaryApprover2={setShowSecondaryApprover2}
                    setShowSecondaryApprover3={setShowSecondaryApprover3}
                    setShowSecondaryApprover4={setShowSecondaryApprover4}
                    setShowTertiaryApprover={setShowTertiaryApprover}
                    setShowTertiaryApprover2={setShowTertiaryApprover2}
                    setShowTertiaryApprover3={setShowTertiaryApprover3}
                    setShowTertiaryApprover4={setShowTertiaryApprover4}
                    setPrimaryApproverFullName={setPrimaryApproverFullName}
                    setPrimaryApproverFullName2={setPrimaryApproverFullName2}
                    setPrimaryApproverFullName3={setPrimaryApproverFullName3}
                    setPrimaryApproverFullName4={setPrimaryApproverFullName4}
                    setSecondaryApproverFullName={setSecondaryApproverFullName}
                    setSecondaryApproverFullName2={setSecondaryApproverFullName2}
                    setSecondaryApproverFullName3={setSecondaryApproverFullName3}
                    setSecondaryApproverFullName4={setSecondaryApproverFullName4}
                    setTertiaryApproverFullName={setTertiaryApproverFullName}
                    setTertiaryApproverFullName2={setTertiaryApproverFullName2}
                    setTertiaryApproverFullName3={setTertiaryApproverFullName3}
                    setTertiaryApproverFullName4={setTertiaryApproverFullName4}
                    setPrimaryApproverId={setPrimaryApproverId}
                    setPrimaryApproverId2={setPrimaryApproverId2}
                    setPrimaryApproverId3={setPrimaryApproverId3}
                    setPrimaryApproverId4={setPrimaryApproverId4}
                    setSecondaryApproverId={setSecondaryApproverId}
                    setSecondaryApproverId2={setSecondaryApproverId2}
                    setSecondaryApproverId3={setSecondaryApproverId3}
                    setSecondaryApproverId4={setSecondaryApproverId4}
                    setTertiaryApproverId={setTertiaryApproverId}
                    setTertiaryApproverId2={setTertiaryApproverId2}
                    setTertiaryApproverId3={setTertiaryApproverId3}
                    setTertiaryApproverId4={setTertiaryApproverId4}
                    handleSubmit={handleSubmit}
            >
            </EditForm>
            { showLocationSelect&&
                <SelectLocation  isOpen={showLocationSelect} 
                        onClose={closeLocationSelect}
                        setLocationId={setLocationId}
                        setLocationDescription={setLocationDescription}
                >
                </SelectLocation>
            }
            { showPrimaryApprover&&
                <PrimaryApprover  isOpen={showPrimaryApprover} 
                        onClose={closePrimaryApprover}
                        setApproverId={setPrimaryApproverId}
                        setApproverName={setPrimaryApproverFullName}
                        mainEmployees={employees}
                >
                </PrimaryApprover>
            }
            { showPrimaryApprover2 &&
                <PrimaryApprover  isOpen={showPrimaryApprover2} 
                        onClose={closePrimaryApprover2}
                        setApproverId={setPrimaryApproverId2}
                        setApproverName={setPrimaryApproverFullName2}
                        mainEmployees={employees}
                >
                </PrimaryApprover>
            }
            { showPrimaryApprover3 &&
                <PrimaryApprover  isOpen={showPrimaryApprover3} 
                        onClose={closePrimaryApprover3}
                        setApproverId={setPrimaryApproverId3}
                        setApproverName={setPrimaryApproverFullName3}
                        mainEmployees={employees}
                >
                </PrimaryApprover>
            }
            { showPrimaryApprover4 &&
                <PrimaryApprover  isOpen={showPrimaryApprover4} 
                    onClose={closePrimaryApprover4}
                    setApproverId={setPrimaryApproverId4}
                    setApproverName={setPrimaryApproverFullName4}
                    mainEmployees={employees}
                >
                </PrimaryApprover>
            }
            { showSecondaryApprover &&
                <SecondaryApprover  isOpen={showSecondaryApprover} 
                        onClose={closeSecondaryApprover}
                        setApproverId={setSecondaryApproverId}
                        setApproverName={setSecondaryApproverFullName}
                        mainEmployees={employees}
                >
                </SecondaryApprover>
            }
            { showSecondaryApprover2 &&
                <SecondaryApprover  isOpen={showSecondaryApprover2} 
                    onClose={closeSecondaryApprover2}
                    setApproverId={setSecondaryApproverId2}
                    setApproverName={setSecondaryApproverFullName2}
                    mainEmployees={employees}
                >
                </SecondaryApprover>
            }
            { showSecondaryApprover3 &&
                <SecondaryApprover  isOpen={showSecondaryApprover3} 
                    onClose={closeSecondaryApprover3}
                    setApproverId={setSecondaryApproverId3}
                    setApproverName={setSecondaryApproverFullName3}
                    mainEmployees={employees}
                >
                </SecondaryApprover>
            }
            { showSecondaryApprover4 &&
                <SecondaryApprover  isOpen={showSecondaryApprover4} 
                    onClose={closeSecondaryApprover4}
                    setApproverId={setSecondaryApproverId4}
                    setApproverName={setSecondaryApproverFullName4}
                    mainEmployees={employees}
                >
                </SecondaryApprover>
            }
            { showTertiaryApprover &&
                <TertiaryApprover  isOpen={showTertiaryApprover} 
                    onClose={closeTertiaryApprover}
                    setApproverId={setTertiaryApproverId}
                    setApproverName={setTertiaryApproverFullName}
                    mainEmployees={employees}
                >
                </TertiaryApprover>
            }
            { showTertiaryApprover2 &&
                <TertiaryApprover  isOpen={showTertiaryApprover2} 
                    onClose={closeTertiaryApprover2}
                    setApproverId={setTertiaryApproverId2}
                    setApproverName={setTertiaryApproverFullName2}
                    mainEmployees={employees}
                >
                </TertiaryApprover>
            }
            { showTertiaryApprover3 &&
                <TertiaryApprover  isOpen={showTertiaryApprover3} 
                    onClose={closeTertiaryApprover3}
                    setApproverId={setTertiaryApproverId3}
                    setApproverName={setTertiaryApproverFullName3}
                    mainEmployees={employees}
                >
                </TertiaryApprover>
            }
            { showTertiaryApprover4 &&
                <TertiaryApprover  isOpen={showTertiaryApprover4} 
                    onClose={closeTertiaryApprover4}
                    setApproverId={setTertiaryApproverId4}
                    setApproverName={setTertiaryApproverFullName4}
                    mainEmployees={employees}
                >
                </TertiaryApprover>
            }
            <ClearForm  isOpen={showClearForm} 
                    onClose={closeClearForm}
                    handleDelete={handleClear}
            >
            </ClearForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest || loading ? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function AddForm({isOpen, 
    onClose, 
    locationDescription,
    locationId,
    primaryApproverId,
    primaryApproverFullName,
    primaryApproverId2,
    primaryApproverFullName2,
    primaryApproverId3,
    primaryApproverFullName3,
    primaryApproverId4,
    primaryApproverFullName4,
    secondaryApproverId,
    secondaryApproverFullName,
    secondaryApproverId2,
    secondaryApproverFullName2,
    secondaryApproverId3,
    secondaryApproverFullName3,
    secondaryApproverId4,
    secondaryApproverFullName4,
    tertiaryApproverId,
    tertiaryApproverFullName,
    tertiaryApproverId2,
    tertiaryApproverFullName2,
    tertiaryApproverId3,
    tertiaryApproverFullName3,
    tertiaryApproverId4,
    tertiaryApproverFullName4,
    setLocationDescription,
    setLocationId,
    setShowLocationSelect,
    setShowPrimaryApprover,
    setShowPrimaryApprover2,
    setShowPrimaryApprover3,
    setShowPrimaryApprover4,
    setShowSecondaryApprover,
    setShowSecondaryApprover2,
    setShowSecondaryApprover3,
    setShowSecondaryApprover4,
    setShowTertiaryApprover,
    setShowTertiaryApprover2,
    setShowTertiaryApprover3,
    setShowTertiaryApprover4,
    setPrimaryApproverFullName,
    setPrimaryApproverFullName2,
    setPrimaryApproverFullName3,
    setPrimaryApproverFullName4,
    setSecondaryApproverFullName,
    setSecondaryApproverFullName2,
    setSecondaryApproverFullName3,
    setSecondaryApproverFullName4,
    setTertiaryApproverFullName,
    setTertiaryApproverFullName2,
    setTertiaryApproverFullName3,
    setTertiaryApproverFullName4,
    setPrimaryApproverId,
    setPrimaryApproverId2,
    setPrimaryApproverId3,
    setPrimaryApproverId4,
    setSecondaryApproverId,
    setSecondaryApproverId2,
    setSecondaryApproverId3,
    setSecondaryApproverId4,
    setTertiaryApproverId,
    setTertiaryApproverId2,
    setTertiaryApproverId3,
    setTertiaryApproverId4,
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(/* (!primaryApproverId && !primaryApproverId2 && !primaryApproverId3 && !primaryApproverId4)
            || (!secondaryApproverId && !secondaryApproverId2 && !secondaryApproverId3 && !secondaryApproverId4)
            || (!tertiaryApproverId && !tertiaryApproverId2 && !tertiaryApproverId3 && !tertiaryApproverId4)
            || */ !locationId
        ){
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setShowPrimaryApprover("");
        setShowPrimaryApprover2("");
        setShowPrimaryApprover3("");
        setShowPrimaryApprover4("");
        setShowSecondaryApprover("");
        setShowSecondaryApprover2("");
        setShowSecondaryApprover3("");
        setShowSecondaryApprover4("");
        setShowTertiaryApprover("");
        setShowTertiaryApprover2("");
        setShowTertiaryApprover3("");
        setShowTertiaryApprover4("");
        setPrimaryApproverFullName("");
        setPrimaryApproverFullName2("");
        setPrimaryApproverFullName3("");
        setPrimaryApproverFullName4("");
        setSecondaryApproverFullName("");
        setSecondaryApproverFullName2("");
        setSecondaryApproverFullName3("");
        setSecondaryApproverFullName4("");
        setTertiaryApproverFullName("");
        setTertiaryApproverFullName2("");
        setTertiaryApproverFullName3("");
        setTertiaryApproverFullName4("");
        setPrimaryApproverId("");
        setPrimaryApproverId2("");
        setPrimaryApproverId3("");
        setPrimaryApproverId4("");
        setSecondaryApproverId("");
        setSecondaryApproverId2("");
        setSecondaryApproverId3("");
        setSecondaryApproverId4("");
        setTertiaryApproverId("");
        setTertiaryApproverId2("");
        setTertiaryApproverId3("");
        setTertiaryApproverId4("");
        setErrorState(false);
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add Approver Hierarchy</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Location</div>
                            <div className="info-item-input row">
                                <input
                                readOnly
                                id="locationDescription"
                                placeholder="Location"
                                value={locationDescription}
                                onChange={(e) => setLocationDescription(e.target.value)}
                                />
                                <button className="select row"
                                    onClick={()=>setShowLocationSelect(true)}
                                ><SearchIcon/></button>
                                { locationId && 
                                    <button className="clear-select row"
                                            onClick={()=>{setLocationId(""); setLocationDescription("")}}
                                            style={{marginLeft: "1px"}}
                                    ><ClearIcon/></button>
                                }
                            </div>
                            <span style={{
                                    visibility: !locationId && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div style={{border: "1px solid #c1c1c1", padding: "10px"}}>
                            <div className="popUp-item info-item column" style={{padding:"0"}}>
                                <div className="info-item-label">Primary Approvers</div>
                                <div className="info-item-input">
                                    <div className="info-item-holder row" style={{flexDirection:"row", justifyContent:"normal", padding:"10px 0"}}>
                                        <input
                                            readOnly
                                            className='employeeInput-select'
                                            placeholder="Primary Approver"
                                            value={primaryApproverFullName}
                                        />
                                        <button className="select row"
                                                onClick={()=>setShowPrimaryApprover(true)}
                                        ><SearchIcon/></button>
                                        { primaryApproverId && 
                                            <button className="clear-select row"
                                                    onClick={()=>{setPrimaryApproverId(""); setPrimaryApproverFullName("")}}
                                                    style={{marginLeft: "1px"}}
                                            ><ClearIcon/></button>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="popUp-item info-item column" style={{padding:"0"}}>
                                <div className="info-item-input">
                                    <div className="info-item-holder row" style={{flexDirection:"row", justifyContent:"normal", padding:"10px 0"}}>
                                        <input
                                            readOnly
                                            className='employeeInput-select'
                                            placeholder="Primary Approver"
                                            value={primaryApproverFullName2}
                                        />
                                        <button className="select row"
                                                onClick={()=>setShowPrimaryApprover2(true)}
                                        ><SearchIcon/></button>
                                        { primaryApproverId2 && 
                                            <button className="clear-select row"
                                                    onClick={()=>{setPrimaryApproverId2(""); setPrimaryApproverFullName2("")}}
                                                    style={{marginLeft: "1px"}}
                                            ><ClearIcon/></button>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="popUp-item info-item column" style={{padding:"0"}}>
                                <div className="info-item-input">
                                    <div className="info-item-holder row" style={{flexDirection:"row", justifyContent:"normal", padding:"10px 0"}}>
                                        <input
                                            readOnly
                                            className='employeeInput-select'
                                            placeholder="Primary Approver"
                                            value={primaryApproverFullName3}
                                        />
                                        <button className="select row"
                                                onClick={()=>setShowPrimaryApprover3(true)}
                                        ><SearchIcon/></button>
                                        { primaryApproverId3 && 
                                            <button className="clear-select row"
                                                    onClick={()=>{setPrimaryApproverId3(""); setPrimaryApproverFullName3("")}}
                                                    style={{marginLeft: "1px"}}
                                            ><ClearIcon/></button>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="popUp-item info-item column" style={{padding:"0"}}>
                                <div className="info-item-input">
                                    <div className="info-item-holder row" style={{flexDirection:"row", justifyContent:"normal", padding:"10px 0"}}>
                                        <input
                                            readOnly
                                            className='employeeInput-select'
                                            placeholder="Primary Approver"
                                            value={primaryApproverFullName4}
                                        />
                                        <button className="select row"
                                                onClick={()=>setShowPrimaryApprover4(true)}
                                        ><SearchIcon/></button>
                                        { primaryApproverId4 && 
                                            <button className="clear-select row"
                                                    onClick={()=>{setPrimaryApproverId4(""); setPrimaryApproverFullName4("")}}
                                                    style={{marginLeft: "1px"}}
                                            ><ClearIcon/></button>
                                        }
                                    </div>
                                </div>
                            </div>
                            <span style={{
                                    visibility: !primaryApproverId && !primaryApproverId2 && !primaryApproverId3 && !primaryApproverId4 && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please select at least 1 approver
                            </span>
                        </div>
                        <div style={{border: "1px solid #c1c1c1", padding: "10px", margin: "10px 0"}}>
                            <div className="popUp-item info-item column" style={{padding:"0"}}>
                                <div className="info-item-label">Secondary Approvers</div>
                                <div className="info-item-input">
                                    <div className="info-item-holder row" style={{flexDirection:"row", justifyContent:"normal", padding:"10px 0"}}>
                                            <input
                                                readOnly
                                                className='employeeInput-select'
                                                placeholder="Secondary Approver"
                                                value={secondaryApproverFullName}
                                            />
                                            <button className="select row"
                                                    onClick={()=>setShowSecondaryApprover(true)}
                                            ><SearchIcon/></button>
                                            { secondaryApproverId && 
                                                <button className="clear-select row"
                                                        onClick={()=>{setSecondaryApproverId(""); setSecondaryApproverFullName("")}}
                                                        style={{marginLeft: "1px"}}
                                                ><ClearIcon/></button>
                                            }
                                    </div>
                                </div>
                            </div>
                            <div className="popUp-item info-item column" style={{padding:"0"}}>
                                <div className="info-item-input">
                                    <div className="info-item-holder row" style={{flexDirection:"row", justifyContent:"normal", padding:"10px 0"}}>
                                            <input
                                                readOnly
                                                className='employeeInput-select'
                                                placeholder="Secondary Approver"
                                                value={secondaryApproverFullName2}
                                            />
                                            <button className="select row"
                                                    onClick={()=>setShowSecondaryApprover2(true)}
                                            ><SearchIcon/></button>
                                            { secondaryApproverId2 && 
                                                <button className="clear-select row"
                                                        onClick={()=>{setSecondaryApproverId2(""); setSecondaryApproverFullName2("")}}
                                                        style={{marginLeft: "1px"}}
                                                ><ClearIcon/></button>
                                            }
                                    </div>
                                </div>
                            </div>
                            <div className="popUp-item info-item column" style={{padding:"0"}}>
                                <div className="info-item-input">
                                    <div className="info-item-holder row" style={{flexDirection:"row", justifyContent:"normal", padding:"10px 0"}}>
                                            <input
                                                readOnly
                                                className='employeeInput-select'
                                                placeholder="Secondary Approver"
                                                value={secondaryApproverFullName3}
                                            />
                                            <button className="select row"
                                                    onClick={()=>setShowSecondaryApprover3(true)}
                                            ><SearchIcon/></button>
                                            { secondaryApproverId3 && 
                                                <button className="clear-select row"
                                                        onClick={()=>{setSecondaryApproverId3(""); setSecondaryApproverFullName3("")}}
                                                        style={{marginLeft: "1px"}}
                                                ><ClearIcon/></button>
                                            }
                                    </div>
                                </div>
                            </div>
                            <div className="popUp-item info-item column" style={{padding:"0"}}>
                                <div className="info-item-input">
                                    <div className="info-item-holder row" style={{flexDirection:"row", justifyContent:"normal", padding:"10px 0"}}>
                                            <input
                                                readOnly
                                                className='employeeInput-select'
                                                placeholder="Secondary Approver"
                                                value={secondaryApproverFullName4}
                                            />
                                            <button className="select row"
                                                    onClick={()=>setShowSecondaryApprover4(true)}
                                            ><SearchIcon/></button>
                                            { secondaryApproverId4 && 
                                                <button className="clear-select row"
                                                        onClick={()=>{setSecondaryApproverId4(""); setSecondaryApproverFullName4("")}}
                                                        style={{marginLeft: "1px"}}
                                                ><ClearIcon/></button>
                                            }
                                    </div>
                                </div>
                            </div>
                            <span style={{
                                    visibility: !secondaryApproverId && !secondaryApproverId2 && !secondaryApproverId3 && !secondaryApproverId4 && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please select at least 1 approver
                            </span>
                        </div>
                        <div style={{border: "1px solid #c1c1c1", padding: "10px", margin: "10px 0"}}>
                            <div className="popUp-item info-item column" style={{padding:"0"}}>
                                <div className="info-item-label">Tertiary Approvers</div>
                                <div className="info-item-input">
                                    <div className="info-item-holder row" style={{flexDirection:"row", justifyContent:"normal", padding:"10px 0"}}>
                                        <input
                                            readOnly
                                            className='employeeInput-select'
                                            placeholder="Tertiary Approver"
                                            value={tertiaryApproverFullName}
                                        />
                                        <button className="select row"
                                                onClick={()=>setShowTertiaryApprover(true)}
                                        ><SearchIcon/></button>
                                        { tertiaryApproverId && 
                                            <button className="clear-select row"
                                                    onClick={()=>{setTertiaryApproverId(""); setTertiaryApproverFullName("")}}
                                                    style={{marginLeft: "1px"}}
                                            ><ClearIcon/></button>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="popUp-item info-item column" style={{padding:"0"}}>
                                <div className="info-item-input">
                                    <div className="info-item-holder row" style={{flexDirection:"row", justifyContent:"normal", padding:"10px 0"}}>
                                        <input
                                            readOnly
                                            className='employeeInput-select'
                                            placeholder="Tertiary Approver"
                                            value={tertiaryApproverFullName2}
                                        />
                                        <button className="select row"
                                                onClick={()=>setShowTertiaryApprover2(true)}
                                        ><SearchIcon/></button>
                                        { tertiaryApproverId2 && 
                                            <button className="clear-select row"
                                                    onClick={()=>{setTertiaryApproverId2(""); setTertiaryApproverFullName2("")}}
                                                    style={{marginLeft: "1px"}}
                                            ><ClearIcon/></button>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="popUp-item info-item column" style={{padding:"0"}}>
                                <div className="info-item-input">
                                    <div className="info-item-holder row" style={{flexDirection:"row", justifyContent:"normal", padding:"10px 0"}}>
                                        <input
                                            readOnly
                                            className='employeeInput-select'
                                            placeholder="Tertiary Approver"
                                            value={tertiaryApproverFullName3}
                                        />
                                        <button className="select row"
                                                onClick={()=>setShowTertiaryApprover3(true)}
                                        ><SearchIcon/></button>
                                        { tertiaryApproverId3 && 
                                            <button className="clear-select row"
                                                    onClick={()=>{setTertiaryApproverId3(""); setTertiaryApproverFullName3("")}}
                                                    style={{marginLeft: "1px"}}
                                            ><ClearIcon/></button>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="popUp-item info-item column" style={{padding:"0"}}>
                                <div className="info-item-input">
                                    <div className="info-item-holder row" style={{flexDirection:"row", justifyContent:"normal", padding:"10px 0"}}>
                                        <input
                                            readOnly
                                            className='employeeInput-select'
                                            placeholder="Tertiary Approver"
                                            value={tertiaryApproverFullName4}
                                        />
                                        <button className="select row"
                                                onClick={()=>setShowTertiaryApprover4(true)}
                                        ><SearchIcon/></button>
                                        { tertiaryApproverId4 && 
                                            <button className="clear-select row"
                                                    onClick={()=>{setTertiaryApproverId4(""); setTertiaryApproverFullName4("")}}
                                                    style={{marginLeft: "1px"}}
                                            ><ClearIcon/></button>
                                        }
                                    </div>
                                </div>
                            </div>
                            <span style={{
                                    visibility:!tertiaryApproverId && !tertiaryApproverId2 && !tertiaryApproverId3 && !tertiaryApproverId4 && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please select at least 1 approver
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EditForm({isOpen, 
    onClose, 
    locationDescription,
    locationId,
    primaryApproverId,
    primaryApproverFullName,
    primaryApproverId2,
    primaryApproverFullName2,
    primaryApproverId3,
    primaryApproverFullName3,
    primaryApproverId4,
    primaryApproverFullName4,
    secondaryApproverId,
    secondaryApproverFullName,
    secondaryApproverId2,
    secondaryApproverFullName2,
    secondaryApproverId3,
    secondaryApproverFullName3,
    secondaryApproverId4,
    secondaryApproverFullName4,
    tertiaryApproverId,
    tertiaryApproverFullName,
    tertiaryApproverId2,
    tertiaryApproverFullName2,
    tertiaryApproverId3,
    tertiaryApproverFullName3,
    tertiaryApproverId4,
    tertiaryApproverFullName4,
    setLocationDescription,
    setLocationId,
    setShowPrimaryApprover,
    setShowPrimaryApprover2,
    setShowPrimaryApprover3,
    setShowPrimaryApprover4,
    setShowSecondaryApprover,
    setShowSecondaryApprover2,
    setShowSecondaryApprover3,
    setShowSecondaryApprover4,
    setShowTertiaryApprover,
    setShowTertiaryApprover2,
    setShowTertiaryApprover3,
    setShowTertiaryApprover4,
    setPrimaryApproverFullName,
    setPrimaryApproverFullName2,
    setPrimaryApproverFullName3,
    setPrimaryApproverFullName4,
    setSecondaryApproverFullName,
    setSecondaryApproverFullName2,
    setSecondaryApproverFullName3,
    setSecondaryApproverFullName4,
    setTertiaryApproverFullName,
    setTertiaryApproverFullName2,
    setTertiaryApproverFullName3,
    setTertiaryApproverFullName4,
    setPrimaryApproverId,
    setPrimaryApproverId2,
    setPrimaryApproverId3,
    setPrimaryApproverId4,
    setSecondaryApproverId,
    setSecondaryApproverId2,
    setSecondaryApproverId3,
    setSecondaryApproverId4,
    setTertiaryApproverId,
    setTertiaryApproverId2,
    setTertiaryApproverId3,
    setTertiaryApproverId4,
    setShowLocationSelect,
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(/* (!primaryApproverId && !primaryApproverId2 && !primaryApproverId3 && !primaryApproverId4)
            || (!secondaryApproverId && !secondaryApproverId2 && !secondaryApproverId3 && !secondaryApproverId4)
            || (!tertiaryApproverId && !tertiaryApproverId2 && !tertiaryApproverId3 && !tertiaryApproverId4)
            || */ !locationId
        ){
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setShowPrimaryApprover("");
        setShowPrimaryApprover2("");
        setShowPrimaryApprover3("");
        setShowPrimaryApprover4("");
        setShowSecondaryApprover("");
        setShowSecondaryApprover2("");
        setShowSecondaryApprover3("");
        setShowSecondaryApprover4("");
        setShowTertiaryApprover("");
        setShowTertiaryApprover2("");
        setShowTertiaryApprover3("");
        setShowTertiaryApprover4("");
        setPrimaryApproverFullName("");
        setPrimaryApproverFullName2("");
        setPrimaryApproverFullName3("");
        setPrimaryApproverFullName4("");
        setSecondaryApproverFullName("");
        setSecondaryApproverFullName2("");
        setSecondaryApproverFullName3("");
        setSecondaryApproverFullName4("");
        setTertiaryApproverFullName("");
        setTertiaryApproverFullName2("");
        setTertiaryApproverFullName3("");
        setTertiaryApproverFullName4("");
        setPrimaryApproverId("");
        setPrimaryApproverId2("");
        setPrimaryApproverId3("");
        setPrimaryApproverId4("");
        setSecondaryApproverId("");
        setSecondaryApproverId2("");
        setSecondaryApproverId3("");
        setSecondaryApproverId4("");
        setTertiaryApproverId("");
        setTertiaryApproverId2("");
        setTertiaryApproverId3("");
        setTertiaryApproverId4("");
        setErrorState(false);
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Update Approver Hierarchy</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Location</div>
                            <div className="info-item-input row">
                                <input
                                readOnly
                                id="locationDescription"
                                placeholder="Location"
                                value={locationDescription}
                                onChange={(e) => setLocationDescription(e.target.value)}
                                style={{cursor:"not-allowed"}}
                                />
                                <button className="select row"
                                    onClick={()=>setShowLocationSelect(true)}
                                ><SearchIcon/></button>
                                { locationId && 
                                    <button className="clear-select row"
                                            onClick={()=>{setLocationId(""); setLocationDescription("")}}
                                            style={{marginLeft: "1px"}}
                                    ><ClearIcon/></button>
                                }
                            </div>
                            <span style={{
                                    visibility: !locationId && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div style={{border: "1px solid #c1c1c1", padding: "10px"}}>
                            <div className="popUp-item info-item column" style={{padding:"0"}}>
                                <div className="info-item-label">Primary Approvers</div>
                                <div className="info-item-input">
                                    <div className="info-item-holder row" style={{flexDirection:"row", justifyContent:"normal", padding:"10px 0"}}>
                                        <input
                                            readOnly
                                            className='employeeInput-select'
                                            placeholder="Primary Approver"
                                            value={primaryApproverFullName}
                                        />
                                        <button className="select row"
                                                onClick={()=>setShowPrimaryApprover(true)}
                                        ><SearchIcon/></button>
                                        { primaryApproverId && 
                                            <button className="clear-select row"
                                                    onClick={()=>{setPrimaryApproverId(""); setPrimaryApproverFullName("")}}
                                                    style={{marginLeft: "1px"}}
                                            ><ClearIcon/></button>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="popUp-item info-item column" style={{padding:"0"}}>
                                <div className="info-item-input">
                                    <div className="info-item-holder row" style={{flexDirection:"row", justifyContent:"normal", padding:"10px 0"}}>
                                        <input
                                            readOnly
                                            className='employeeInput-select'
                                            placeholder="Primary Approver"
                                            value={primaryApproverFullName2}
                                        />
                                        <button className="select row"
                                                onClick={()=>setShowPrimaryApprover2(true)}
                                        ><SearchIcon/></button>
                                        { primaryApproverId2 && 
                                            <button className="clear-select row"
                                                    onClick={()=>{setPrimaryApproverId2(""); setPrimaryApproverFullName2("")}}
                                                    style={{marginLeft: "1px"}}
                                            ><ClearIcon/></button>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="popUp-item info-item column" style={{padding:"0"}}>
                                <div className="info-item-input">
                                    <div className="info-item-holder row" style={{flexDirection:"row", justifyContent:"normal", padding:"10px 0"}}>
                                        <input
                                            readOnly
                                            className='employeeInput-select'
                                            placeholder="Primary Approver"
                                            value={primaryApproverFullName3}
                                        />
                                        <button className="select row"
                                                onClick={()=>setShowPrimaryApprover3(true)}
                                        ><SearchIcon/></button>
                                        { primaryApproverId3 && 
                                            <button className="clear-select row"
                                                    onClick={()=>{setPrimaryApproverId3(""); setPrimaryApproverFullName3("")}}
                                                    style={{marginLeft: "1px"}}
                                            ><ClearIcon/></button>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="popUp-item info-item column" style={{padding:"0"}}>
                                <div className="info-item-input">
                                    <div className="info-item-holder row" style={{flexDirection:"row", justifyContent:"normal", padding:"10px 0"}}>
                                        <input
                                            readOnly
                                            className='employeeInput-select'
                                            placeholder="Primary Approver"
                                            value={primaryApproverFullName4}
                                        />
                                        <button className="select row"
                                                onClick={()=>setShowPrimaryApprover4(true)}
                                        ><SearchIcon/></button>
                                        { primaryApproverId4 && 
                                            <button className="clear-select row"
                                                    onClick={()=>{setPrimaryApproverId4(""); setPrimaryApproverFullName4("")}}
                                                    style={{marginLeft: "1px"}}
                                            ><ClearIcon/></button>
                                        }
                                    </div>
                                </div>
                            </div>
                            <span style={{
                                    visibility: !primaryApproverId && !primaryApproverId2 && !primaryApproverId3 && !primaryApproverId4 && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please select at least 1 approver
                            </span>
                        </div>
                        <div style={{border: "1px solid #c1c1c1", padding: "10px", margin: "10px 0"}}>
                            <div className="popUp-item info-item column" style={{padding:"0"}}>
                                <div className="info-item-label">Secondary Approvers</div>
                                <div className="info-item-input">
                                    <div className="info-item-holder row" style={{flexDirection:"row", justifyContent:"normal", padding:"10px 0"}}>
                                            <input
                                                readOnly
                                                className='employeeInput-select'
                                                placeholder="Secondary Approver"
                                                value={secondaryApproverFullName}
                                            />
                                            <button className="select row"
                                                    onClick={()=>setShowSecondaryApprover(true)}
                                            ><SearchIcon/></button>
                                            { secondaryApproverId && 
                                                <button className="clear-select row"
                                                        onClick={()=>{setSecondaryApproverId(""); setSecondaryApproverFullName("")}}
                                                        style={{marginLeft: "1px"}}
                                                ><ClearIcon/></button>
                                            }
                                    </div>
                                </div>
                            </div>
                            <div className="popUp-item info-item column" style={{padding:"0"}}>
                                <div className="info-item-input">
                                    <div className="info-item-holder row" style={{flexDirection:"row", justifyContent:"normal", padding:"10px 0"}}>
                                            <input
                                                readOnly
                                                className='employeeInput-select'
                                                placeholder="Secondary Approver"
                                                value={secondaryApproverFullName2}
                                            />
                                            <button className="select row"
                                                    onClick={()=>setShowSecondaryApprover2(true)}
                                            ><SearchIcon/></button>
                                            { secondaryApproverId2 && 
                                                <button className="clear-select row"
                                                        onClick={()=>{setSecondaryApproverId2(""); setSecondaryApproverFullName2("")}}
                                                        style={{marginLeft: "1px"}}
                                                ><ClearIcon/></button>
                                            }
                                    </div>
                                </div>
                            </div>
                            <div className="popUp-item info-item column" style={{padding:"0"}}>
                                <div className="info-item-input">
                                    <div className="info-item-holder row" style={{flexDirection:"row", justifyContent:"normal", padding:"10px 0"}}>
                                            <input
                                                readOnly
                                                className='employeeInput-select'
                                                placeholder="Secondary Approver"
                                                value={secondaryApproverFullName3}
                                            />
                                            <button className="select row"
                                                    onClick={()=>setShowSecondaryApprover3(true)}
                                            ><SearchIcon/></button>
                                            { secondaryApproverId3 && 
                                                <button className="clear-select row"
                                                        onClick={()=>{setSecondaryApproverId3(""); setSecondaryApproverFullName3("")}}
                                                        style={{marginLeft: "1px"}}
                                                ><ClearIcon/></button>
                                            }
                                    </div>
                                </div>
                            </div>
                            <div className="popUp-item info-item column" style={{padding:"0"}}>
                                <div className="info-item-input">
                                    <div className="info-item-holder row" style={{flexDirection:"row", justifyContent:"normal", padding:"10px 0"}}>
                                            <input
                                                readOnly
                                                className='employeeInput-select'
                                                placeholder="Secondary Approver"
                                                value={secondaryApproverFullName4}
                                            />
                                            <button className="select row"
                                                    onClick={()=>setShowSecondaryApprover4(true)}
                                            ><SearchIcon/></button>
                                            { secondaryApproverId4 && 
                                                <button className="clear-select row"
                                                        onClick={()=>{setSecondaryApproverId4(""); setSecondaryApproverFullName4("")}}
                                                        style={{marginLeft: "1px"}}
                                                ><ClearIcon/></button>
                                            }
                                    </div>
                                </div>
                            </div>
                            <span style={{
                                    visibility: !secondaryApproverId && !secondaryApproverId2 && !secondaryApproverId3 && !secondaryApproverId4 && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please select at least 1 approver
                            </span>
                        </div>
                        <div style={{border: "1px solid #c1c1c1", padding: "10px", margin: "10px 0"}}>
                            <div className="popUp-item info-item column" style={{padding:"0"}}>
                                <div className="info-item-label">Tertiary Approvers</div>
                                <div className="info-item-input">
                                    <div className="info-item-holder row" style={{flexDirection:"row", justifyContent:"normal", padding:"10px 0"}}>
                                        <input
                                            readOnly
                                            className='employeeInput-select'
                                            placeholder="Tertiary Approver"
                                            value={tertiaryApproverFullName}
                                        />
                                        <button className="select row"
                                                onClick={()=>setShowTertiaryApprover(true)}
                                        ><SearchIcon/></button>
                                        { tertiaryApproverId && 
                                            <button className="clear-select row"
                                                    onClick={()=>{setTertiaryApproverId(""); setTertiaryApproverFullName("")}}
                                                    style={{marginLeft: "1px"}}
                                            ><ClearIcon/></button>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="popUp-item info-item column" style={{padding:"0"}}>
                                <div className="info-item-input">
                                    <div className="info-item-holder row" style={{flexDirection:"row", justifyContent:"normal", padding:"10px 0"}}>
                                        <input
                                            readOnly
                                            className='employeeInput-select'
                                            placeholder="Tertiary Approver"
                                            value={tertiaryApproverFullName2}
                                        />
                                        <button className="select row"
                                                onClick={()=>setShowTertiaryApprover2(true)}
                                        ><SearchIcon/></button>
                                        { tertiaryApproverId2 && 
                                            <button className="clear-select row"
                                                    onClick={()=>{setTertiaryApproverId2(""); setTertiaryApproverFullName2("")}}
                                                    style={{marginLeft: "1px"}}
                                            ><ClearIcon/></button>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="popUp-item info-item column" style={{padding:"0"}}>
                                <div className="info-item-input">
                                    <div className="info-item-holder row" style={{flexDirection:"row", justifyContent:"normal", padding:"10px 0"}}>
                                        <input
                                            readOnly
                                            className='employeeInput-select'
                                            placeholder="Tertiary Approver"
                                            value={tertiaryApproverFullName3}
                                        />
                                        <button className="select row"
                                                onClick={()=>setShowTertiaryApprover3(true)}
                                        ><SearchIcon/></button>
                                        { tertiaryApproverId3 && 
                                            <button className="clear-select row"
                                                    onClick={()=>{setTertiaryApproverId3(""); setTertiaryApproverFullName3("")}}
                                                    style={{marginLeft: "1px"}}
                                            ><ClearIcon/></button>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="popUp-item info-item column" style={{padding:"0"}}>
                                <div className="info-item-input">
                                    <div className="info-item-holder row" style={{flexDirection:"row", justifyContent:"normal", padding:"10px 0"}}>
                                        <input
                                            readOnly
                                            className='employeeInput-select'
                                            placeholder="Tertiary Approver"
                                            value={tertiaryApproverFullName4}
                                        />
                                        <button className="select row"
                                                onClick={()=>setShowTertiaryApprover4(true)}
                                        ><SearchIcon/></button>
                                        { tertiaryApproverId4 && 
                                            <button className="clear-select row"
                                                    onClick={()=>{setTertiaryApproverId4(""); setTertiaryApproverFullName4("")}}
                                                    style={{marginLeft: "1px"}}
                                            ><ClearIcon/></button>
                                        }
                                    </div>
                                </div>
                            </div>
                            <span style={{
                                    visibility:!tertiaryApproverId && !tertiaryApproverId2 && !tertiaryApproverId3 && !tertiaryApproverId4 && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please select at least 1 approver
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function SelectLocation({isOpen, 
    onClose,
    setLocationId,
    setLocationDescription}) 
{
    var header = [
        "Id",
        "Description",
    ]
    var accessor = [
        "id",
        "description"
    ]

    const handleClose = () => {
        onClose();
        fetchData();
    };
    const handleProceed = () => {
        onClose();
        setLocationId(selectedLocation.id);
        setLocationDescription(selectedLocation.description);
        fetchData();
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [locations, setLocations] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Location/active";

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        setLocations(response.data); // Set the response data to the state
            setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }
    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.description.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.id.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.description.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setLocations(res);
    };

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by name")
                break;
            case 1:
                setSearchPlaceholder("Search by id")
                break;
            default:
                setSearchPlaceholder("Search by name")
                break;
        }
        if(isOpen){
            fetchData();
        }
    }, [filterDataIndex, isOpen]);
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Select Employee</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="transaction-body">
                            <EmployeeFilter setFilterDataIndex={setFilterDataIndex}/>
                            <div className="transaction-body-top row">
                                {CreateSearchBarWithPlaceHolder("", 
                                                                "transaction-search row", 
                                                                "transaction-search-icon", 
                                                                "transaction-search-input", 
                                                                (e)=>handleFilter(e.target.value), 
                                                                searchPlaceholder,
                                                                SearchIcon)}
                            </div>
                        </div>
                    <div className="popUp-body">
                        <div className="select-employee-table">
                            <CreateTableForEmployeeSelect
                                dataList={locations}
                                dataHeader={header}
                                dataAccessor={accessor}
                                setSelectedEmployee={setSelectedLocation}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {locations.length > 0 ? (
                                    <div></div>
                            )
                            :
                            (
                                <div>
                                    {loading ? (
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                            <img src={loadingSpinner} alt="Loading..." />
                                        </div>
                                    ) : (
                                            <div> {/*<p>No records to display</p>*/}</div>
                                        )
                                    }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"50px 20px 0 20px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleProceed}>
                                PROCEED
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function PrimaryApprover({isOpen, 
    onClose,
    setApproverId,
    setApproverName,
    mainEmployees
}) 
{
    var header = [
        "Id",
        "Name",
    ]
    var accessor = [
        "employeeId",
        "fullName"
    ]

    const handleClose = () => {
        onClose();
    };
    const handleProceed = () => {
        onClose();
        setApproverId(selectedEmployee.id);
        setApproverName(selectedEmployee.fullName);
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [employees, setEmployees] = useState(mainEmployees);
    const filterData = mainEmployees;
    const [selectedEmployee, setSelectedEmployee] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeeId.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setEmployees(res);
    };

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by name")
                break;
            case 1:
                setSearchPlaceholder("Search by id")
                break;
            default:
                setSearchPlaceholder("Search by name")
                break;
        }
    }, [filterDataIndex]);
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Select Employee</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="transaction-body">
                            <EmployeeFilter setFilterDataIndex={setFilterDataIndex}/>
                            <div className="transaction-body-top row">
                                {CreateSearchBarWithPlaceHolder("", 
                                                                "transaction-search row", 
                                                                "transaction-search-icon", 
                                                                "transaction-search-input", 
                                                                (e)=>handleFilter(e.target.value), 
                                                                searchPlaceholder,
                                                                SearchIcon)}
                            </div>
                        </div>
                    <div className="popUp-body">
                        <div className="select-employee-table">
                            <CreateTableForEmployeeSelect
                                dataList={employees}
                                dataHeader={header}
                                dataAccessor={accessor}
                                setSelectedEmployee={setSelectedEmployee}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {employees.length > 0 ? (
                                    <div></div>
                            )
                            :
                            (
                                <div>
                                    <div> {/*<p>No records to display</p>*/}</div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"50px 20px 0 20px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleProceed}>
                                PROCEED
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function SecondaryApprover({isOpen, 
    onClose,
    setApproverId,
    setApproverName,
    mainEmployees
}) 
{
    var header = [
        "Id",
        "Name",
    ]
    var accessor = [
        "employeeId",
        "fullName"
    ]

    const handleClose = () => {
        onClose();
    };
    const handleProceed = () => {
        onClose();
        setApproverId(selectedEmployee.id);
        setApproverName(selectedEmployee.fullName);
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [employees, setEmployees] = useState(mainEmployees);
    const filterData = mainEmployees;
    const [selectedEmployee, setSelectedEmployee] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeeId.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setEmployees(res);
    };

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by name")
                break;
            case 1:
                setSearchPlaceholder("Search by id")
                break;
            default:
                setSearchPlaceholder("Search by name")
                break;
        }
    }, [filterDataIndex]);
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Select Employee</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="transaction-body">
                            <EmployeeFilter setFilterDataIndex={setFilterDataIndex}/>
                            <div className="transaction-body-top row">
                                {CreateSearchBarWithPlaceHolder("", 
                                                                "transaction-search row", 
                                                                "transaction-search-icon", 
                                                                "transaction-search-input", 
                                                                (e)=>handleFilter(e.target.value), 
                                                                searchPlaceholder,
                                                                SearchIcon)}
                            </div>
                        </div>
                    <div className="popUp-body">
                        <div className="select-employee-table">
                            <CreateTableForEmployeeSelect
                                dataList={employees}
                                dataHeader={header}
                                dataAccessor={accessor}
                                setSelectedEmployee={setSelectedEmployee}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {employees.length > 0 ? (
                                    <div></div>
                            )
                            :
                            (
                                <div>
                                    <div> {/*<p>No records to display</p>*/}</div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"50px 20px 0 20px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleProceed}>
                                PROCEED
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function TertiaryApprover({isOpen, 
    onClose,
    setApproverId,
    setApproverName,
    mainEmployees
}) 
{
    var header = [
        "Id",
        "Name",
    ]
    var accessor = [
        "employeeId",
        "fullName"
    ]

    const handleClose = () => {
        onClose();
    };
    const handleProceed = () => {
        onClose();
        setApproverId(selectedEmployee.id);
        setApproverName(selectedEmployee.fullName);
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [employees, setEmployees] = useState(mainEmployees);
    const filterData = mainEmployees;
    const [selectedEmployee, setSelectedEmployee] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeeId.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setEmployees(res);
    };

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by name")
                break;
            case 1:
                setSearchPlaceholder("Search by id")
                break;
            default:
                setSearchPlaceholder("Search by name")
                break;
        }
    }, [filterDataIndex]);
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Select Employee</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="transaction-body">
                            <EmployeeFilter setFilterDataIndex={setFilterDataIndex}/>
                            <div className="transaction-body-top row">
                                {CreateSearchBarWithPlaceHolder("", 
                                                                "transaction-search row", 
                                                                "transaction-search-icon", 
                                                                "transaction-search-input", 
                                                                (e)=>handleFilter(e.target.value), 
                                                                searchPlaceholder,
                                                                SearchIcon)}
                            </div>
                        </div>
                    <div className="popUp-body">
                        <div className="select-employee-table">
                            <CreateTableForEmployeeSelect
                                dataList={employees}
                                dataHeader={header}
                                dataAccessor={accessor}
                                setSelectedEmployee={setSelectedEmployee}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {employees.length > 0 ? (
                                    <div></div>
                            )
                            :
                            (
                                <div>
                                    <div> {/*<p>No records to display</p>*/}</div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"50px 20px 0 20px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleProceed}>
                                PROCEED
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EmployeeFilter({setFilterDataIndex}){
    const [selectedOption, setSelectedOption] = useState("All");

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="EmployeeId">Employee Id</option>
            </select>
        </div>
    );
};
function ClearForm({isOpen, 
    onClose, 
    handleDelete}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Clear!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to clear approver?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleDelete}
                            style={{marginRight:"5px"}}>
                                CLEAR
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
export function CreateTable({ dataList = [], dataHeader = [], dataAccessor = [], currentPage, setCurrentPage, editHandleClick, deleteHandleClick, employees }) {
    // const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <>
            <table {...getTableProps()} className='border-collapse'>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                {...column.getHeaderProps()}
                                onClick={() => headerClick(column)}
                                className="sortable-header"
                            >
                                {`${column.render("Header")} ${
                                    sortHeaderValue.id === column.id
                                        ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                        : ""
                                }`}
                            </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            >
                                {row.cells.map((cell) => (
                                    <SetInfo header={cell.render("Cell").props.column.Header}
                                            _cell={cell}
                                            editHandleClick={editHandleClick}
                                            deleteHandleClick={deleteHandleClick}
                                            employees={employees}/>
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </>
            ) :
            <></>}
        </>
    )
}
function SetInfo({header, _cell, editHandleClick, deleteHandleClick, employees}) {
    const data = _cell.render("Cell").props.row.original;
    const value = _cell.render("Cell").props.value;

    if (header === "") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="Update">
                        <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><ModeEditIcon/></div>
                    </Tooltip>
                    { deleteHandleClick ? 
                    <Tooltip text="Clear">
                        <div style={{padding:"0 5px"}} onClick={()=>deleteHandleClick(data)}><DeleteForeverIcon/></div>
                    </Tooltip>
                    :
                    <></>
                    }
                </div>
            </td>
        )
    }

    if (header === "Employee Id") {
        const employeeInfo = employees.find(employee => employee.id === value);

        return (
            <td>
                {employeeInfo.employeeId}
            </td>
        )
    }

    if (header === "Primary Approver") {
        if (data.primaryApprovers && data.primaryApprovers.length > 0) {
            return (
                <td>
                    {data.primaryApprovers.map((approver, index) => (
                        <React.Fragment key={index}>
                            {approver.approverFullName}
                            {index < data.primaryApprovers.length - 1 && <br />}
                        </React.Fragment>
                    ))}
                </td>
            );
        } else {
            return <td></td>;
        }
    }

    if (header === "Secondary Approver") {
        if (data.secondaryApprovers && data.secondaryApprovers.length > 0) {
            return (
                <td>
                    {data.secondaryApprovers.map((approver, index) => (
                        <React.Fragment key={index}>
                            {approver.approverFullName}
                            {index < data.secondaryApprovers.length - 1 && <br />}
                        </React.Fragment>
                    ))}
                </td>
            );
        } else {
            return <td></td>;
        }
    }

    if (header === "Tertiary Approver") {
        if (data.tertiaryApprovers && data.tertiaryApprovers.length > 0) {
            return (
                <td>
                    {data.tertiaryApprovers.map((approver, index) => (
                        <React.Fragment key={index}>
                            {approver.approverFullName}
                            {index < data.tertiaryApprovers.length - 1 && <br />}
                        </React.Fragment>
                    ))}
                </td>
            );
        } else {
            return <td></td>;
        }
    }

    return (
        <td {..._cell.getCellProps()}> {
            _cell.render("Cell")
            }
        </td>
    )
}
const Tooltip = ({ text, children }) => {
    const [show, setShow] = useState(false);

    const handleMouseEnter = () => {
        setShow(true);
    };

    const handleMouseLeave = () => {
        setShow(false);
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block',zIndex:"1" }}>
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            </div>
            {show && (
            <div
                style={{
                position: 'absolute',
                top: '50%',
                left: '-50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'white',
                color: 'gray',
                padding: '5px',
                borderRadius: '5px',
                pointerEvents: "none",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                }}
            >
                {text}
            </div>
            )}
        </div>
    );
};
export default ApproverHierarchyPerLocation
